import 'lazysizes';
window.axios = require('axios');
window._ = require('lodash/core');
window.$ = require('cash-dom');

// default script vars
window.g_dev = false;
window.g_windowHeight = window.offsetHeight;
window.g_windowWidth = window.offsetWidth;
window.g_scroll = window.pageYOffset;
window.scrollMargin = 0;
window.scrollTreshold = 0;

window.addEventListener('scroll', function(event){
    g_scroll = window.pageYOffset;
});

window.addEventListener('resize', function(event){
    g_windowHeight = window.offsetHeight;
    g_windowWidth = window.offsetWidth;
});

require('./scripts/get-siblings');
require('./scripts/cookie-consent');
require('./scripts/cookie-consent-banner');
require('./scripts/header-popups');
require('./scripts/newsletter');
require('./scripts/popup');
require('./scripts/smoothscroll');
require('./scripts/toggle');
require('./scripts/tooltip');
require('./scripts/sliders');
require('./scripts/lightbox');
require('./scripts/fixed-header');

// legacy scripts
require('./scripts/mobile-menu');
require('./scripts/equalheight');
